module.exports = __webpack_public_path__ + "img/right.87488426.svg";